import './src/styles/index.scss';
import 'pure-react-carousel/dist/react-carousel.es.css';
